'use client';

import { IconButton, SvgIcon } from '@mui/material';
import { whatsappIcon } from '../../config/icons';

// Hardcoded WhatsApp number
const WHATSAPP_PHONE_NUMBER = '+972559895695';

export function WhatsappButton({ handleClick }: { handleClick?: () => void }) {
  const handleWhatsappClick = () => {
    handleClick?.();

    const message = `היי, ראיתי את הפרויקט הזה ביד2 אשמח לקבל פרטים נוספים.

קישור למודעה:
${window.location.origin + window.location.pathname}

*שליחת הפנייה כפופה לתקנון ולמדיניות הפרטיות המופיעים באתר יד2*
*נא לא לערוך את ההודעה – כדי שנוכל לטפל בפנייה*

https://www.2.yad2.co.il/eula
https://www.2.yad2.co.il/privacy`;

    const encodedMessage = encodeURIComponent(message);

    window.open(
      `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE_NUMBER}&text=${encodedMessage}`,
      '_blank',
    );
  };

  return (
    <IconButton
      onClick={handleWhatsappClick}
      color="success"
      data-treedistestid="button-whatsapp-contact"
      sx={{
        backgroundColor: 'success.main',
        borderRadius: '12px',
        color: 'common.white',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: 'success.main',
          opacity: 0.7,
        },
      }}
    >
      <SvgIcon sx={{ width: '24px', height: '24px' }}>{whatsappIcon}</SvgIcon>
    </IconButton>
  );
}
